// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TwoFactorToggle.css */
.two-factor-section {
  width: 100%;
  margin: 1rem 0;
}

.two-factor-container {
  background-color: var(--background-consistent);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 0.5rem;
  padding: 1rem;
}

.two-factor-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.two-factor-text h4 {
  margin: 0;
  font-size: 1rem;
  font-weight: 500;
}

.two-factor-text p {
  margin: 0.25rem 0 0;
  font-size: 0.875rem;
  color: #666;
}

.two-factor-controls {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.info-button {
  background: none;
  border: 1px solid #ccc;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  color: #666;
}

.info-button:hover {
  background-color: #f5f5f5;
}

/* Toggle Switch Styles */
.toggle {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 24px;
}

.toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 24px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: var(--theme-consistent);
}

input:checked + .slider:before {
  transform: translateX(24px);
}

/* Info Panel Styles */
.two-factor-info {
  margin-top: 1rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 0.5rem;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.two-factor-info h5 {
  margin: 0 0 0.75rem 0;
  font-size: 0.875rem;
  font-weight: 500;
}

.two-factor-info ul {
  margin: 0;
  padding-left: 1.25rem;
  list-style-type: disc;
}

.two-factor-info li {
  margin: 0.25rem 0;
  font-size: 0.875rem;
  color: #666;
}

@media screen and (max-width: 768px) {
  .two-factor-content {
    flex-direction: column;
    align-items: flex-start;
  }

  .two-factor-controls {
    width: 100%;
    justify-content: flex-end;
    margin-top: 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/TwoFactorToggle.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,8CAA8C;EAC9C,oCAAoC;EACpC,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,kBAAkB;EACpB;AACF","sourcesContent":["/* TwoFactorToggle.css */\n.two-factor-section {\n  width: 100%;\n  margin: 1rem 0;\n}\n\n.two-factor-container {\n  background-color: var(--background-consistent);\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 0.5rem;\n  padding: 1rem;\n}\n\n.two-factor-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n}\n\n.two-factor-text h4 {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 500;\n}\n\n.two-factor-text p {\n  margin: 0.25rem 0 0;\n  font-size: 0.875rem;\n  color: #666;\n}\n\n.two-factor-controls {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.info-button {\n  background: none;\n  border: 1px solid #ccc;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.875rem;\n  color: #666;\n}\n\n.info-button:hover {\n  background-color: #f5f5f5;\n}\n\n/* Toggle Switch Styles */\n.toggle {\n  position: relative;\n  display: inline-block;\n  width: 48px;\n  height: 24px;\n}\n\n.toggle input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: 0.4s;\n  border-radius: 24px;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 20px;\n  width: 20px;\n  left: 2px;\n  bottom: 2px;\n  background-color: white;\n  transition: 0.4s;\n  border-radius: 50%;\n}\n\ninput:checked + .slider {\n  background-color: var(--theme-consistent);\n}\n\ninput:checked + .slider:before {\n  transform: translateX(24px);\n}\n\n/* Info Panel Styles */\n.two-factor-info {\n  margin-top: 1rem;\n  padding: 1rem;\n  background-color: #f8f9fa;\n  border-radius: 0.5rem;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.two-factor-info h5 {\n  margin: 0 0 0.75rem 0;\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.two-factor-info ul {\n  margin: 0;\n  padding-left: 1.25rem;\n  list-style-type: disc;\n}\n\n.two-factor-info li {\n  margin: 0.25rem 0;\n  font-size: 0.875rem;\n  color: #666;\n}\n\n@media screen and (max-width: 768px) {\n  .two-factor-content {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .two-factor-controls {\n    width: 100%;\n    justify-content: flex-end;\n    margin-top: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
